import { createRouter, createWebHistory } from 'vue-router'
import * as Auth from '@/services/Auth'
import DashboardView from '@/views/DashboardView.vue'
import HomeView from '@/views/HomeView.vue'
import LoginView from '@/views/auth/LoginView.vue'
import TournamentShowView from '@/views/Tournament/TournamentShowView.vue'
import TournamentLayout from '@/views/TournamentLayout.vue'
import { setPageTitle } from '@/services/utils'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('@/views/TestView.vue'),
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('@/views/AboutView.vue'),
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('@/views/PrivacyView.vue'),
    },
    {
      path: '/info',
      name: 'info',
      component: () => import('@/views/InfoView.vue'),
    },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: () => import('@/views/LoginView.vue'),
    //   meta: { requiresGuest: true } // Only accessible when not logged in
    // },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: DashboardView,
      meta: { requiresAuth: true } // Only accessible when logged in
    },
    {
      path: '/tournament/new',
      name: 'tournament-new',
      component: () => import('@/views/TournamentNewView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/t/:slug',
      component: TournamentLayout,
      children: [
        {
          path: 'actions',
          name: 'tournament-actions',
          component: () => import('@/views/Tournament/TournamentActions.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'entries',
          name: 'tournament-entries',
          component: () => import('@/views/Tournament/TournamentEntries.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'teams',
          name: 'tournament-teams',
          component: () => import('@/views/Tournament/TournamentTeams.vue'),
          meta: { requiresAuth: true }
        },
        // {
        //   path: 'teams-standings',
        //   name: 'tournament-teams-standings',
        //   component: () => import('@/views/Tournament/StandingsTeams.vue'),
        //   meta: { requiresAuth: true }
        // },
        {
          path: 'info',
          name: 'tournament-info',
          component: () => import('@/views/Tournament/Info.vue'),
        },
        {
          path: 'hof',
          name: 'tournament-hof',
          component: () => import('@/views/Tournament/Hof.vue'),
        },
        {
          path: 'format',
          name: 'tournament-format',
          component: () => import('@/views/Tournament/TournamentFormat.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'settings',
          name: 'tournament-settings',
          component: () => import('@/views/Tournament/TournamentSettings.vue'),
          meta: { requiresAuth: true }
        },
        {
          path: 'round/:round?',
          name: 'tournament-round',
          component: () => import('@/views/Tournament/GroupRound.vue'),
        },
        {
          path: '',
          name: 'tournament-show',
          component: TournamentShowView,
        },
      ]
    },

    // {
    //   path: '/reset-password',
    //   name: 'reset-password',
    //   component: () => import('@/views/ResetPasswordView.vue'),
    //   meta: { requiresGuest: true }
    // },
    // {
    //   path: '/password/reset/:token',
    //   name: 'reset-password-confirm',
    //   component: () => import('@/views/ResetPasswordConfirmView.vue'),
    //   meta: { requiresGuest: true }
    // },
    // {
    //   path: '/register',
    //   name: 'register',
    //   component: () => import('@/views/RegisterView.vue'),
    //   meta: { requiresGuest: true }
    // },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/ProfileView.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/views/SettingsView.vue'),
      meta: { requiresAuth: true }
    },

    // Auth routes
    {
      path: '/login',
      name: 'login',
      component: LoginView
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/auth/RegisterView.vue'),
    },
    {
      path: '/forgot-password',
      name: 'forgot_password',
      component: () => import('@/views/auth/ForgotPasswordView.vue'),
    },
    {
      path: '/reset-password',
      name: 'reset_password',
      component: () => import('@/views/auth/ResetPasswordView.vue'),
    },


    // Catch-all route for 404 Page Not Found
    {
      path: '/:pathMatch(.*)*',
      name: 'notfound',
      component: () => import('@/views/PageNotFound.vue'),
    },
  ],
})

// Navigation guard
router.beforeEach((to, from, next) => {
  const isAuthenticated = Auth.isAuthenticated()
  
  // Routes that require the user to be a guest (not logged in)
  if (to.meta.requiresGuest && isAuthenticated) {
    next({ name: 'home' })
    return
  }
  
  // Routes that require authentication
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'login' })
    return
  }
  
  next()
})


// Aggiorna il titolo della pagina ad ogni navigazione
router.beforeEach((to) => {
  if (!to.path.startsWith('/tournament/')) {
    setPageTitle(null)
  }
})

router.afterEach((to) => {
  if (typeof window !== 'undefined' && window.scrollTo) {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }
})

export default router
